import { SymbolInfo } from 'symbols/symbolInfo/symbolInfoSlice';
import React from 'react';
import './SymbolInfoDisplay.scss';

export function SymbolInfoDisplay(props: { info: SymbolInfo }) {
    const { info } = props;
    return (
        <div className="SymbolInfoDisplay">
            <div className="row">
                <div className="title">Instinet Symbol</div>
                <div className="value">{info.iSymbol}</div>
            </div>
            <div className="row">
                <div className="title">Bloom Symbol</div>
                <div className="value">{info.bloomSymbol}</div>
            </div>
            <div className="row">
                <div className="title">Description</div>
                <div className="value full-width" title={info.description}>
                    {info.description}
                </div>
            </div>
            <div className="row">
                <div className="title">Region</div>
                <div className="value">{info.region}</div>
            </div>
            <div className="row">
                <div className="title">Country</div>
                <div className="value">{info.country}</div>
            </div>
            <div className="row">
                <div className="title">Currency Code</div>
                <div className="value">{info.currencyCode}</div>
            </div>
            <div className="row">
                <div className="title">Asset Class</div>
                <div className="value">{info.assetClass}</div>
            </div>
            <div className="row">
                <div className="title">Isin</div>
                <div className="value">{info.isin}</div>
            </div>
            <div className="row">
                <div className="title">Exchange Symbol</div>
                <div className="value">{info.exchangeSymbol}</div>
            </div>
            <div className="row">
                <div className="title">Symbol Index</div>
                <div className="value">{info.symbolIndex}</div>
            </div>
            <div className="row">
                <div className="title">Industry</div>
                <div className="value">{info.industry}</div>
            </div>
            <div className="row">
                <div className="title">Sector</div>
                <div className="value">{info.sector}</div>
            </div>
            <div className="row">
                <div className="title">Sub-Industry</div>
                <div className="value">{info.subIndustry}</div>
            </div>
            <div className="row">
                <div className="title">Super Sector</div>
                <div className="value">{info.superSector}</div>
            </div>
            <div className="row">
                <div className="title">Security Type</div>
                <div className="value">{info.securityType}</div>
            </div>
        </div>
    );
}
